import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import moment from "moment";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";

export default function StockDetail() {
  let { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [pageStates, setPageStates] = useState({
    PO_Data: [],
    Grn_Data: [],
    StockOut_Data: [],
    TransferIn_Data: [],
    TransferOut_Data: [],
    tableLoaderPoWise: false,
    tableLoaderGrn: false,
    tableLoaderStockOut: false,
    stockTotals: {
      poQuantity: 0,
      grnQuantity: 0,
      stockOutQuantity: 0,
      transferInQuantity: 0,
      transferOutQuantity: 0,
    },
  });

  useEffect(() => {
    GetPoData();
    GetGrnData();
    GetStockOutData();
    GetTransferInData();
  }, []);

  const GetPoData = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl?.get_purchase + `itemId=${id}&siteId=${location?.state?.siteId}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoaderPoWise: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoaderPoWise: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.purchase?.map((item) => ({
          ...item,
          quantity:
            item?.purchaserequest?.purchaserequestexpenseheads?.[0]
              ?.supplyrequestitems?.[0]?.updatedQuantity,
          receivedQuantity:
            item?.purchaserequest?.purchaserequestexpenseheads?.[0]
              ?.supplyrequestitems?.[0]?.receivedQuantity || "0",
          Date: moment(item?.purchaseDate).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
        }));
        const totalPoQty = newData.reduce(
          (sum, item) => sum + Number(item.quantity || 0),
          0
        );
        setPageStates((prev) => ({
          ...prev,
          PO_Data: newData,
          stockTotals: {
            ...prev.stockTotals,
            poQuantity: totalPoQty,
          },
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  const GetGrnData = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl?.get_GRN +
      `itemId=${id}&siteId=${location?.state?.siteId}&from=stock`;
    setPageStates((prev) => ({
      ...prev,
      tableLoaderGrn: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoaderGrn: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.grn?.map((item) => ({
          ...item,
          quantity: item?.grnheads?.[0]?.grnitems?.[0]?.quantity,
          grnDate: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
        }));
        const totalGrnQty = newData.reduce(
          (sum, item) => sum + Number(item.quantity || 0),
          0
        );
        setPageStates((prev) => ({
          ...prev,
          Grn_Data: newData,
          stockTotals: {
            ...prev.stockTotals,
            grnQuantity: totalGrnQty,
          },
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  const GetStockOutData = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl?.get_stock_out + `itemId=${id}&siteId=${location?.state?.siteId}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoaderStockOut: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoaderStockOut: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.stockOut?.map((item) => ({
          ...item,
          quantity: item?.StockOutItems?.[0]?.quantity,
          stockOutDate: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
        }));
        const totalStockOutQty = newData.reduce(
          (sum, item) => sum + Number(item.quantity || 0),
          0
        );
        setPageStates((prev) => ({
          ...prev,
          StockOut_Data: newData,
          stockTotals: {
            ...prev.stockTotals,
            stockOutQuantity: totalStockOutQty,
          },
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  const GetTransferInData = () => {
    const options = { method: "GET" };
    const API = `${apiUrl?.get_transfer_asset}?itemId=${id}&siteId=${location?.state?.siteId}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoaderStockOut: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoaderStockOut: false,
      }));

      if (response?.status === true) {
        const currentSiteId = location?.state?.siteId;

        let transferIn = [];
        let transferOut = [];
        let transferInQty = 0;
        let transferOutQty = 0;

        response?.data?.transferAsset?.forEach((item) => {
          const formattedItem = {
            ...item,
            fromSite: item?.fromSite?.name,
            toSite: item?.toSite?.name,
            quantity: Number(item?.transferassetitems?.[0]?.quantity || 0),
            transferDate: moment(item?.date).format("DD-MM-YYYY"),
            createdBy: item?.user?.name,
          };

          if (item?.fromSiteId === currentSiteId) {
            transferOut.push(formattedItem);
            transferOutQty += formattedItem.quantity;
          } else {
            transferIn.push(formattedItem);
            transferInQty += formattedItem.quantity;
          }
        });

        setPageStates((prev) => ({
          ...prev,
          TransferIn_Data: transferIn,
          TransferOut_Data: transferOut,
          stockTotals: {
            ...prev.stockTotals,
            transferInQuantity: transferInQty,
            transferOutQuantity: transferOutQty,
          },
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  const PoHeading = [
    { value: "purchaseNumber", label: "Po Number" },
    { value: "quantity", label: "Po Quantity" },
    { value: "receivedQuantity", label: "Receivedd Quantity" },
    { value: "Date", label: "Date" },
    { value: "createdBy", label: "Created By" },
  ];
  const StockInHeading = [
    { value: "grnNumber", label: "GRN Number" },
    { value: "quantity", label: "Quantity" },
    { value: "grnDate", label: "Date" },
    { value: "createdBy", label: "Created By" },
  ];
  const StockOutHeading = [
    { value: "stockOutNumber", label: "Stock Out Number" },
    { value: "quantity", label: "Quantity" },
    { value: "stockOutDate", label: "Date" },
    { value: "createdBy", label: "Created By" },
  ];
  const TransferHeading = [
    { value: "taNumber", label: "Transfer Number" },
    { value: "fromSite", label: "From Site" },
    { value: "toSite", label: "To Site" },
    { value: "quantity", label: "Quantity" },
    { value: "transferDate", label: "Date" },
    { value: "createdBy", label: "Transfered   By" },
  ];

  return (
    <>
      <div className="content container-fluid">
        <MainHeading title="Stock Detail" showBackButton={true} />
        <div className="card manage-user-list">
          <div className="card-body">
            <div className="card-header bg-light py-3 px-4 rounded-3 mb-4 shadow-sm">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center text-primary-emphasis gap-2">
                <h3 className="mb-0">
                  <i className="bi bi-box-seam me-2"></i>
                  <strong>Item Name:</strong> {location?.state?.name}
                </h3>
                {location?.state?.siteName && <h4 className="mb-0">
                  <i className="bi bi-geo-alt-fill me-2"></i>
                  <strong>Site:</strong> {location?.state?.siteName}
                </h4>}
              </div>
            </div>

            <div className="bg-body-tertiary rounded-4 p-4 mb-5 border">
              <div className="row text-center">
                {[
                  {
                    label: "PO Qty",
                    value: pageStates?.stockTotals?.poQuantity || 0,
                  },
                  {
                    label: "Stock In Qty (GRN)",
                    value: pageStates?.stockTotals?.grnQuantity || 0,
                  },
                  {
                    label: "Stock Out Qty",
                    value: pageStates?.stockTotals?.stockOutQuantity || 0,
                  },
                  {
                    label: "Transfer In Qty",
                    value: pageStates?.stockTotals?.transferInQuantity || 0,
                  },
                  {
                    label: "Transfer Out Qty",
                    value: pageStates?.stockTotals?.transferOutQuantity || 0,
                  },
                  {
                    label: "Available Stock",
                    value:
                      (pageStates?.stockTotals?.grnQuantity || 0) +
                      (pageStates?.stockTotals?.transferInQuantity || 0) -
                      ((pageStates?.stockTotals?.stockOutQuantity || 0) +
                        (pageStates?.stockTotals?.transferOutQuantity || 0)),
                  },
                ].map((item, idx) => (
                  <div className="col" key={idx}>
                    <div className="bg-light p-3 rounded-3 shadow-sm h-100">
                      <p className="mb-1 fw-semibold text-muted">
                        {item.label}
                      </p>
                      <h4 className="mb-0 text-dark">{item.value}</h4>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-12 mt-3">
              <div className="d-flex align-items-center justify-content-center my-4">
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "1px" }}
                ></div>
                <h4 className="fs-3 fw-semibold badge bg-primary rounded-5 mx-3">
                  PO Data
                </h4>
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "1px" }}
                ></div>
              </div>
              <CommonTable
                TableHeading={PoHeading}
                TableData={pageStates?.PO_Data}
              />
            </div>
            <div className="col-12 mt-5">
              <div className="d-flex align-items-center justify-content-center my-4">
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "1px" }}
                ></div>
                <h4 className="fs-3 fw-semibold badge bg-primary rounded-5 mx-3">
                  Stock In Data
                </h4>
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "1px" }}
                ></div>
              </div>
              <CommonTable
                TableHeading={StockInHeading}
                TableData={pageStates?.Grn_Data}
              />
            </div>
            <div className="col-12 mt-5">
              <div className="d-flex align-items-center justify-content-center my-4">
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "4px" }}
                ></div>
                <h4 className="fs-3 fw-semibold badge bg-primary rounded-5 mx-3">
                  Stock Out Data
                </h4>
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "1px" }}
                ></div>
              </div>
              <CommonTable
                TableHeading={StockOutHeading}
                TableData={pageStates?.StockOut_Data}
              />
            </div>
            <div className="col-12 mt-5">
              <div className="d-flex align-items-center justify-content-center my-4">
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "4px" }}
                ></div>
                <h4 className="fs-3 fw-semibold badge bg-primary rounded-5 mx-3">
                  Transfer In Data
                </h4>
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "1px" }}
                ></div>
              </div>
              <CommonTable
                TableHeading={TransferHeading}
                TableData={pageStates?.TransferIn_Data}
              />
            </div>
            <div className="col-12 mt-5">
              <div className="d-flex align-items-center justify-content-center my-4">
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "4px" }}
                ></div>
                <h4 className="fs-3 fw-semibold badge bg-primary rounded-5 mx-3">
                  Transfer Out Data
                </h4>
                <div
                  className="flex-grow-1 border-bottom border-primary-subtle"
                  style={{ height: "1px" }}
                ></div>
              </div>
              <CommonTable
                TableHeading={TransferHeading}
                TableData={pageStates?.TransferOut_Data}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
